import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { query_client } from './lib/query-client';
import { init_theme } from './lib/theme-store';
import { Toaster } from './components/ui/toaster';
import App from './App';
import './index.css';

const root_el = document.getElementById('root');
if (!root_el) throw new Error('#root element not found');

// Before first paint, so a dark-mode console never flashes the light palette.
init_theme();

createRoot(root_el).render(
  <StrictMode>
    <QueryClientProvider client={query_client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* Outside the router: a toast raised by a mutation must survive the
          navigation that mutation triggers. */}
      <Toaster />
      {/*
        Off unless explicitly asked for, via VITE_QUERY_DEVTOOLS=1.

        Two reasons. It was rendering in production builds, so a client-facing
        console shipped a query inspector. And its floating toggle is fixed to
        the bottom-right corner, exactly where the table's last-page button
        sits — it silently swallowed clicks on that control, which is how a
        real pagination bug and a dev-only overlay looked identical.
      */}
      {import.meta.env.VITE_QUERY_DEVTOOLS === '1' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </StrictMode>,
);
